<template>
  <div v-if="isThumbnail" class="h-full mx-auto" :style="{ maxHeight: 'calc(100% - 2.5rem)'}">
    <img :src="block.embed.poster" :alt="block.title" class="w-full h-full object-cover" />
  </div>

  <div v-else :id="`player-${block.id}`" class="h-full">
    <turbo-frame
      :id="`embed_${block.embed.id}`"
      :src="`/embeds/${block.embed.id}`"
      :class="youtubeWrapperClass"
      :style="youtubeStyle"
      data-provider="youtube"
      data-youtube-target="video"
      loading="lazy">
      <div :class="youtubeVideoClass" class="w-full h-full rounded-lg animate-pulse bg-gray-200"></div>
    </turbo-frame>
  </div>
</template>

<script setup>
import { toRef, onMounted, watch, defineProps, inject } from 'vue'
import { useEmbedHelpers } from '../../composables/useEmbedHelpers'
import { useYouTubePlayer } from '../../composables/useYouTubePlayer'

const props = defineProps({
  block: {
    type: Object,
    required: true
  },
  isThumbnail: {
    type: Boolean,
    default: false
  },
})

const embedRef = toRef(props.block, 'embed')
const { initYouTubePlayer } = useYouTubePlayer(props.block.id)
const { youtubeWrapperClass, youtubeStyle, youtubeVideoClass } = useEmbedHelpers(embedRef)

const getVideoId = () => {
  return (
    props.block.embed.external_embed_id ||
    new URL(props.block.embed.original_url).searchParams.get('v')
  )
}
onMounted(() => {
  if (props.isThumbnail) return

  if (window.YT) {
    initYouTubePlayer(getVideoId(), {
      start_seconds: props.block.embed.start,
      end_seconds: props.block.embed.end,
      thumbnail: props.isThumbnail,
    })
  } else {
    console.error('YouTube API not loaded')
  }
})

watch(
  () => [
    props.block.embed.original_url,
    props.block.embed.start,
    props.block.embed.end,
  ],
  () => {
    if (!props.isThumbnail) {
      const videoEl = document.querySelector('[data-controller="video-player"]')
      videoEl.parentElement.src = videoEl.parentElement.src
    }
  }
)
</script>
